import { FC, useEffect } from "react";
import { useNavigate } from "react-router";
import { routes } from "../../App";
import { useGetAgentStateQuery } from "../../redux/apis/blenderApi";
import FullScreenSpinner from "../presenters/FullScreenSpinner";

const StateBasedRedirect: FC = () => {
  const { data: agentState, isLoading } = useGetAgentStateQuery();
  const navigate = useNavigate();

  useEffect(
    () => {
      if (agentState) {
        if (agentState.state === "LoggedOut")
          void navigate(routes.loggedOut);
        else
          void navigate(routes.home);
      }
    },
    [agentState, navigate],
  );

  if (isLoading || !agentState)
    return <FullScreenSpinner />;
};

export default StateBasedRedirect;
